import styled from 'styled-components';

import { Text } from '@atom/typography/typography';
import { ColorEnum } from '@enum/style/color.enum';

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: auto max(120px);
  width: 100%;
`;

export const TextBlock = styled(Text).attrs({
  color: ColorEnum.Black90,
  level: 'm',
})`
  width: 120px;
  display: flex;
  align-items: center;
  padding-left: 4px;
  padding-top: 24px;
`;
